import React from 'react';

import { Grid, Tooltip, Hidden, MenuItem } from '@material-ui/core';

import { EmployeeGroups } from '../employee-groups/components/employee-groups';
import { UiButton } from '../ui/ui-button';
import { UiKebabMenu } from '../ui/ui-kebab-menu';

import { EmployeeStatus } from './employee-status';
import { EmployeeSupervisors } from './employee-supervisors';
import { EmployeeTeamEngineBadge } from './employee-team-engine-badge';

import { EmployeeNotesButton } from './widgets/employee-notes-button';
import { getHrisDisplayName } from '../merge-integration/util/merge-display-utils';
import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

export const EmployeeSummaryCard = ({
  employee,
  org,
  hasAllEmployeesPermission,
  viewDetail,
  viewNotes,
  message,
  mergeIntegration,
  hrisIntegrationResponse,
}: {
  employee: Employee;
  org: Org;
  hasAllEmployeesPermission: boolean;
  viewDetail: () => void;
  viewNotes: () => void;
  message: () => void;
  mergeIntegration?: MergeIntegration;
  hrisIntegrationResponse?: HrisIntegrationResponse;
}) => (
  <div className="u-padding-lg u-border-top" key={`employee-${employee.employeeId}`}>
    <Grid container spacing={2} alignContent="center" alignItems="center">
      <Grid item sm={3} md={hasAllEmployeesPermission ? 2 : 3}>
        <div
          role="presentation"
          onClick={viewDetail}
          className="typo-title u-cursor-pointer u-display-flex u-alignItems-center"
        >
          {employee.nickname || employee.Contact.Person.firstName}
        </div>
      </Grid>
      <Grid item sm={3} md={hasAllEmployeesPermission ? 2 : 3}>
        <div
          role="presentation"
          onClick={viewDetail}
          className="typo-title u-cursor-pointer u-display-flex u-alignItems-center"
        >
          {employee.Contact.Person.lastName}
          {employee.username && (
            <Tooltip title="Team Engine User" placement="top">
              <span className="u-height-fitContent">
                <MaterialDesignIcon
                  iconName={ICON_NAMES.VERIFIED_USER}
                  color="primary"
                  className="u-margin-left-xs u-margin-top-xs"
                  size="sm"
                />
              </span>
            </Tooltip>
          )}
        </div>
        {(org?.QuickbooksIntegration || mergeIntegration) && !employee.integrationId && (
          <div className="u-display-flex u-color-gray">
            <MaterialDesignIcon
              iconName={ICON_NAMES.LINK_OFF}
              className="u-margin-right-xs"
              size="sm"
            />
            <div>
              Missing in{' '}
              {org?.QuickbooksIntegration
                ? 'Quickbooks'
                : getHrisDisplayName(mergeIntegration, hrisIntegrationResponse) ||
                  'HR/payroll system'}
            </div>
          </div>
        )}
        <EmployeeTeamEngineBadge employeeId={employee.employeeId} />
      </Grid>
      <Hidden smDown>
        <Grid item md={2}>
          <EmployeeGroups employee={employee} />
        </Grid>
      </Hidden>
      {hasAllEmployeesPermission && (
        <Hidden smDown>
          <Grid item md={2}>
            <EmployeeSupervisors employee={employee} />
          </Grid>
        </Hidden>
      )}
      <Hidden smDown>
        <Grid item md={2}>
          <EmployeeStatus employee={employee} />
        </Grid>
      </Hidden>
      <Grid container item sm={6} md={2} justifyContent="flex-end">
        <UiButton variant="tertiary" onClick={message}>
          Message
        </UiButton>
        <EmployeeNotesButton
          className="u-margin-left-sm"
          employeeId={employee.employeeId}
          onClick={viewNotes}
        />
        <UiKebabMenu
          menuId="employeeDirectoryMoreOptionsMenu"
          className="u-zIndex-100 u-padding-xs"
          stopPropagation
        >
          <MenuItem onClick={viewDetail}>View Profile</MenuItem>
        </UiKebabMenu>
      </Grid>
    </Grid>
  </div>
);
